
  export function getIdToken() {
    const tokenID = sessionStorage.getItem('idToken')
    // console.log("tokenid en auth.ts:",tokenID);
    return tokenID;
  }

  export function getAccessToken() {
    const token = sessionStorage.getItem('accessToken');
    // console.log("accessToken en auth.ts:",token);
    return token;
  }